<template>
    <div class="multiple-checkboxes">
       <label v-for="choice in choices">
           <input type="checkbox" :name="name" :value="choice[0]" @change="onChange" v-model="widget_value">
           {{ choice[1] }}
       </label>
    </div>
</template>

<script>

export default {
  name: 'MultiCheckbox',
  props: [
      'choices',
      'name',
      'value',
  ],
  data() {
    let val = this.value
    if (!Array.isArray(val)) {
        val = []
    }
    return {
        widget_value: val,
    }
  },

  methods: {
      onChange(e) {
          console.info('change', this.widget_value)
          this.$emit('input', this.widget_value)
          this.$emit('change', e)
      }
  },
//   watch:{
//     //   value(val) {
//     //       this.widget_value = val
//     //   }
//   },
}
</script>
